import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    const name = reason.name || reason.cause.name;
    const msg = String(reason.message || reason.cause.message || "").toLowerCase();
    if (name === "AbortError" || msg.includes("aborted")) {
      event.preventDefault();
    }
  });

  window.addEventListener("error", (event) => {
    const err = event.error;
    const name = err.name || err.cause.name;
    const msg = String(err.message || err.cause.message || "").toLowerCase();
    if (name === "AbortError" || msg.includes("aborted")) {
      event.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <App />
);
